// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/projects/v1/vision_location.proto (package protos.vision.projects.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/projects/v1/vision_location.proto.
 */
export const file_vision_projects_v1_vision_location: GenFile = /*@__PURE__*/
  fileDesc("Cih2aXNpb24vcHJvamVjdHMvdjEvdmlzaW9uX2xvY2F0aW9uLnByb3RvEhlwcm90b3MudmlzaW9uLnByb2plY3RzLnYxIrgBCg5WaXNpb25Mb2NhdGlvbhITCgtsb2NhdGlvbl9pZBgBIAEoCRIMCgRuYW1lGAIgASgJEg8KB2FkZHJlc3MYAyABKAkSEgoKc29ydF9vcmRlchgEIAEoBRIuCgpjcmVhdGVkX2F0GAUgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GAYgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcGIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * @generated from message protos.vision.projects.v1.VisionLocation
 */
export type VisionLocation = Message<"protos.vision.projects.v1.VisionLocation"> & {
  /**
   * @generated from field: string location_id = 1;
   */
  locationId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string address = 3;
   */
  address: string;

  /**
   * @generated from field: int32 sort_order = 4;
   */
  sortOrder: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message protos.vision.projects.v1.VisionLocation.
 * Use `create(VisionLocationSchema)` to create a new message.
 */
export const VisionLocationSchema: GenMessage<VisionLocation> = /*@__PURE__*/
  messageDesc(file_vision_projects_v1_vision_location, 0);

